<template>
    <div class="clear-link-container">
        <h2 class="title"> Filters <i class="fa-solid fa-plus" @click="showMobileFilter()" v-if="is_mobile"></i></h2>
        <a href="#" @click.prevent="clearFilter" class="clear-link" v-if="filters.size">Clear All Filters
            <i class="fa-regular fa-circle-xmark fa-lg" id="search_form_close"></i>
        </a>
    </div>
</template>
<script>

export default {
    props: {
        clearFilter: Function,
        filters: Set,
        showMobileFilter: {
            type: Function,
            required: false
        },
        is_mobile: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.fa-plus {
    display: none;

    @include xl {
        display: initial;
        margin-left: 5px;
    }
}

.clear-link {
    margin-bottom: 16px;

    i {
        margin-left: 8px;
    }
}

.clear-link-container {
    display: grid;
}

a {
    position: relative;
    display: block;
    color: #0b3148;
    font-size: 14px;
    text-decoration: underline;
}

.title {
    font-size: 26px;
}
</style>